module.exports = __webpack_public_path__ + "img/two1.0769eeb4.png";